import { createContext, useMemo, useState } from "react";
import { IChildrenProps } from "../../Interfaces/IChildrenProps";

interface ILoaderProps {
    isLoading: boolean,
    toggleLoading: (show: boolean) => void
}

export const LoaderContext = createContext({} as ILoaderProps);

const LoaderContextProvider = ({ children }: IChildrenProps) => {
    const [loading, setLoading] = useState<boolean>(false);

    const toggleLoading = (show: boolean) => {
        setLoading(show);
    }

    const value = useMemo(
        () => ({ isLoading: loading, toggleLoading }),
        [loading]
    );

    return (
        <LoaderContext.Provider value={value}>
            { children }
        </LoaderContext.Provider>
    )
}

export default LoaderContextProvider;
